"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Accordion = require("./Accordion");

var _Accordion2 = _interopRequireDefault(_Accordion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Accordion2.default;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-accordion@0.0.1@@alicd/crui-accordion/lib/index.js
// module id = 504
// module chunks = 0